import $ from 'jquery';
import ApexCharts from 'apexcharts';

$(function () {
    const $container = $('#portfolio-rebalance-app');
    if (!$container.length) return;

    let currency = $container.data('currency') || 'USD';
    let symbol = currency === 'USD' ? '$' : currency === 'EUR' ? '€' : currency === 'PLN' ? 'zł' : '₴';
    let chartInstance = null;

    const textMoreCurrencies = $container.data('text-more-currencies') || 'Ще валюти';
    const textMoreShort = $container.data('text-more-short') || 'Ще';

    const $initBtn = $('#rebal-currency-tabs button.active');
    if ($initBtn.length) {
        currency = $initBtn.data('currency-code') || currency;
        symbol = $initBtn.data('symbol') || symbol;
    }

    const culture = $container.data('culture') || 'uk-UA';
    const localeMap = { 'uk': 'uk-UA', 'pl': 'pl-PL', 'de': 'de-DE', 'es': 'es-ES', 'it': 'it-IT', 'en': 'en-US' };
    const dateLocale = localeMap[culture] || 'en-US';

    const colAsset = $container.data('col-asset') || 'Назва активу';
    const colCurrent = $container.data('col-current') || 'Поточна вартість';
    const colTarget = $container.data('col-target') || 'Цільова частка (%)';
    const colAction = $container.data('col-action') || 'Докупити на суму';
    const btnDelete = $container.data('btn-delete') || 'Видалити';
    const defaultAsset = $container.data('default-asset') || 'Актив';
    const summaryTmpl = $container.data('summary-tmpl') || 'Увесь {contribution} щомісячний внесок розподілено між активами, які відстають від цілі. Ви наблизили портфель до балансу без жодного продажу, заощадивши близько {taxesSaved} на податках на приріст капіталу та брокерських комісіях.';
    const seriesCurrent = $container.data('series-current') || 'Поточна частка';
    const seriesPost = $container.data('series-post') || 'Після докупки';
    const seriesTarget = $container.data('series-target') || 'Цільова частка';

    const $contribRange = $('#rebal-contribution-range');
    const $contribDisplay = $('#rebal-contribution-display');

    function formatMoney(num) {
        return Math.round(num).toLocaleString(dateLocale) + ' ' + symbol;
    }

    function calculate() {
        const contribution = parseFloat($contribRange.val()) || 1000;
        $contribDisplay.text(formatMoney(contribution));

        const assets = [];
        let totalCurrentVal = 0;
        let totalTargetPct = 0;

        $('.rebal-asset-row').each(function () {
            const name = $(this).find('.asset-name').val() || defaultAsset;
            const currentVal = parseFloat($(this).find('.asset-current-val').val()) || 0;
            const targetPct = parseFloat($(this).find('.asset-target-pct').val()) || 0;

            assets.push({ $row: $(this), name, currentVal, targetPct });
            totalCurrentVal += currentVal;
            totalTargetPct += targetPct;
        });

        const $sumBadge = $('#rebal-target-sum-badge');
        $sumBadge.text(totalTargetPct + '%');
        if (totalTargetPct === 100) {
            $sumBadge.removeClass('bg-danger bg-warning').addClass('bg-success');
        } else if (totalTargetPct > 100) {
            $sumBadge.removeClass('bg-success bg-warning').addClass('bg-danger');
        } else {
            $sumBadge.removeClass('bg-success bg-danger').addClass('bg-warning');
        }

        const newTotalVal = totalCurrentVal + contribution;
        let totalDeficit = 0;

        assets.forEach(a => {
            const targetVal = newTotalVal * (a.targetPct / 100);
            const deficit = Math.max(0, targetVal - a.currentVal);
            a.deficit = deficit;
            totalDeficit += deficit;
        });

        let driftSum = 0;
        let totalExcessSold = 0;

        const currentWeights = [];
        const postWeights = [];
        const targetWeights = [];
        const assetLabels = [];

        assets.forEach(a => {
            let buyAmount = 0;
            if (totalDeficit > 0 && a.deficit > 0) {
                buyAmount = Math.min(contribution, (a.deficit / totalDeficit) * contribution);
            } else if (totalDeficit === 0) {
                buyAmount = contribution * (a.targetPct / 100);
            }

            a.buyAmount = buyAmount;
            a.$row.find('.asset-action-recommendation').text('+' + formatMoney(buyAmount));

            const currentPct = totalCurrentVal > 0 ? (a.currentVal / totalCurrentVal) * 100 : 0;
            const postVal = a.currentVal + buyAmount;
            const postPct = newTotalVal > 0 ? (postVal / newTotalVal) * 100 : 0;

            driftSum += Math.abs(currentPct - a.targetPct);

            const targetVal = totalCurrentVal * (a.targetPct / 100);
            if (a.currentVal > targetVal) {
                totalExcessSold += (a.currentVal - targetVal);
            }

            assetLabels.push(a.name);
            currentWeights.push(parseFloat(currentPct.toFixed(1)));
            postWeights.push(parseFloat(postPct.toFixed(1)));
            targetWeights.push(parseFloat(a.targetPct.toFixed(1)));
        });

        const driftIndex = (driftSum / 2).toFixed(1);
        const estimatedGainRate = 0.40; // 40% capital gain in profitable assets
        const taxRate = 0.195; // 19.5% tax rate
        const taxesSaved = Math.round(totalExcessSold * estimatedGainRate * taxRate);

        $('#rebal-kpi-drift').text(driftIndex + '%');
        $('#rebal-kpi-tax').text('+' + formatMoney(taxesSaved));
        $('#rebal-kpi-total').text(formatMoney(newTotalVal));

        const summaryMsg = summaryTmpl
            .replace('{contribution}', formatMoney(contribution))
            .replace('{taxesSaved}', formatMoney(taxesSaved));
        $('#rebal-summary-text').text(summaryMsg);

        renderChart(assetLabels, currentWeights, postWeights, targetWeights);
    }

    function renderChart(labels, currentWeights, postWeights, targetWeights) {
        const isDark = $('body').hasClass('dark') || $('body').attr('data-layout-mode') === 'dark';

        const options = {
            series: [
                { name: seriesCurrent, data: currentWeights },
                { name: seriesPost, data: postWeights },
                { name: seriesTarget, data: targetWeights }
            ],
            chart: {
                type: 'bar',
                height: 280,
                toolbar: { show: false }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '55%',
                    endingShape: 'rounded'
                }
            },
            dataLabels: { enabled: false },
            colors: ['#74788d', '#34c38f', '#556ee6'],
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },
            xaxis: {
                categories: labels,
                labels: {
                    style: { colors: isDark ? '#a6b0cf' : '#74788d' },
                    rotate: -20
                }
            },
            yaxis: {
                title: { text: '%' },
                labels: {
                    formatter: function (val) {
                        return val + '%';
                    },
                    style: { colors: isDark ? '#a6b0cf' : '#74788d' }
                }
            },
            fill: { opacity: 1 },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + '%';
                    }
                }
            },
            legend: {
                position: 'top',
                horizontalAlign: 'right',
                labels: { colors: isDark ? '#a6b0cf' : '#74788d' }
            },
            grid: {
                borderColor: isDark ? '#32394e' : '#f1f1f1'
            }
        };

        const chartEl = document.querySelector('#portfolio-rebalance-chart');
        if (!chartEl) return;

        if (chartInstance) {
            chartInstance.updateOptions(options);
        } else {
            chartInstance = new ApexCharts(chartEl, options);
            chartInstance.render();
        }
    }

    // Input listeners
    $contribRange.on('input', calculate);
    $(document).on('input', '.asset-current-val, .asset-target-pct, .asset-name', calculate);

    // Add Asset Row
    $('#btn-add-rebal-asset').on('click', function () {
        const count = $('.rebal-asset-row').length;
        const newRow = `
            <div class="rebal-asset-row p-3 border rounded bg-light" data-index="${count}">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <input type="text" class="form-control form-control-sm fw-semibold asset-name me-2" value="${colAsset} ${count + 1}">
                    <button type="button" class="btn btn-sm btn-link text-danger p-0 btn-remove-asset" title="${btnDelete}">
                        <i class="bx bx-trash font-size-16"></i>
                    </button>
                </div>
                <div class="row g-2">
                    <div class="col-6">
                        <label class="font-size-11 text-muted mb-0">${colCurrent}</label>
                        <input type="number" class="form-control form-control-sm asset-current-val" value="5000" step="100">
                    </div>
                    <div class="col-6">
                        <label class="font-size-11 text-muted mb-0">${colTarget}</label>
                        <input type="number" class="form-control form-control-sm asset-target-pct" value="10" step="1" min="0" max="100">
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-2 pt-2 border-top">
                    <span class="font-size-12 text-muted">${colAction}:</span>
                    <span class="font-size-13 fw-bold text-success asset-action-recommendation">+$0</span>
                </div>
            </div>`;
        $('#rebal-assets-container').append(newRow);
        calculate();
    });

    // Remove Asset Row
    $(document).on('click', '.btn-remove-asset', function () {
        if ($('.rebal-asset-row').length > 1) {
            $(this).closest('.rebal-asset-row').remove();
            calculate();
        }
    });

    // Currency Switcher
    function setRebalCurrency(btn, isDropdown) {
        currency = $(btn).data('currency-code');
        symbol = $(btn).data('symbol') || '$';

        if (isDropdown) {
            $('#rebal-currency-tabs > button[data-currency-code]').removeClass('active');
            $('.rebal-currency-dropdown-item').removeClass('active');
            $(btn).addClass('active');
            $('.rebal-more-currencies-btn').addClass('active');
            $('#rebal-active-custom-currency').text(`${symbol} ${currency}`);
        } else {
            $('#rebal-currency-tabs button').removeClass('active');
            $(btn).addClass('active');
            $('.rebal-more-currencies-btn').removeClass('active');
            $('.rebal-currency-dropdown-item').removeClass('active');
            $('#rebal-active-custom-currency').html(`
                <span class="d-none d-sm-inline">${textMoreCurrencies}</span>
                <span class="d-sm-none">${textMoreShort}</span>
            `);
        }

        const defContrib = parseFloat($(btn).data('contribution')) || 1000;
        $contribRange.val(defContrib);

        if (currency === 'UAH' || currency === 'CZK') {
            $contribRange.attr({ min: 1000, max: 200000, step: 1000 });
        } else if (currency === 'PLN') {
            $contribRange.attr({ min: 200, max: 25000, step: 200 });
        } else {
            $contribRange.attr({ min: 100, max: 20000, step: 50 });
        }

        calculate();
    }

    $('#rebal-currency-tabs > button[data-currency-code]').on('click', function () {
        setRebalCurrency(this, false);
    });

    $(document).on('click', '.rebal-currency-dropdown-item', function (e) {
        e.preventDefault();
        setRebalCurrency(this, true);
    });

    calculate();
});

